import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        // Check both 'status' (ApiError) and 'statusCode' (ApiClientError)
        if (error instanceof Error && ('status' in error || 'statusCode' in error)) {
          const status =
            (error as { status?: number }).status ??
            (error as { statusCode?: number }).statusCode;
          if (status !== undefined && status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
